var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.position.x,
        "position-y": _vm.position.y,
        "close-on-content-click": false,
        "close-on-click": _vm.closeOnClick,
        "nudge-width": _vm.nudgeWidth,
        "offset-x": "",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", {
            staticClass: "title py-3",
            domProps: { innerHTML: _vm._s(_vm.params.title) },
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("v-card-text", {
            domProps: { innerHTML: _vm._s(_vm.params.text) },
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: _vm.params.color || "error",
                    outline: _vm.outline,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _vm.params.icon
                    ? _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v(_vm._s(_vm.params.icon)),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n        " + _vm._s(_vm.params.confirmText) + "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-btn", {
                attrs: { color: "secondary", outline: "" },
                domProps: { innerHTML: _vm._s(_vm.params.cancelText) },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }